module.exports = __webpack_public_path__ + "a90d055cbcd6af0b2d5dcd06341ad688.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/wcxs.png
// module id = 284
// module chunks = 0